import React, { useContext, useEffect, useState } from "react";

import {
  Box,
  Typography,
  Button,
  TextField,
  Tooltip,
  InputAdornment,
} from "@material-ui/core";

import helpOutlineIcon from '../../../../../assets/images/helpOutline.svg'

import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import WarningIcon from "@material-ui/icons/Warning";

import useStyles from "./styles";
import { AutoRegistrationContext } from "../../../context/AutoRegistrationProvider";
import { useFormik } from "formik";
import {
  validationSchemaDriver,
  validationSchemaTransporter,
} from "./validationSchema";
import { createNewUserExchangeNotes } from "../../../../../api/exchangeNotes";
import { ConfirmFinish } from "../../../components/ConfirmFinish";
import { toast } from "react-toastify";
import InputMask from "react-input-mask";

import InsertInvitationIcon from "@material-ui/icons/InsertInvitation";

export const NotesSecondStep = ({ isTransporter, changeStep }) => {
  const { data, setData } = useContext(AutoRegistrationContext);
  const [isDone, setIsDone] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const classes = useStyles();

  const postToken = document.cookie?.split('post_token=')[1]?.split(';')[0]

  useEffect(() => {
    if (!postToken) {
      window.location.href = '/application/Login/index'
    }
  }, [postToken])


  const handleSubmitForm = (values) => {
    setIsLoading(true)
    const day = values.expirationDate.split("/")[0];
    const month = values.expirationDate.split("/")[1];
    const year = values.expirationDate.split("/")[2];

    const serverDate = `${year}-${month}-${day}`;

    const formatData = {
      ...data,
      "external-id": values?.cnh,
      "license-expiration": serverDate,
      "toll-number": values?.toll,
      "loading-order[]": values?.loadingOrder,
      "tn[]": values?.numberTN,
      "post_token": values?.postToken,
      "description-name[]": values?.socialReason,
    };
    setData(formatData);

    const formValues = new FormData()

    for (let key in formatData) {
      formValues.append(key, formatData[key])
    }

    createNewUserExchangeNotes("/Login/signUP", formValues)
      .then((resp) => {
        if (resp.data.error) {
          if (resp.data.error.includes('loadOrder') || resp.data.error.includes('Ordem de Carregamento')) {
            formik.setFieldError('loadingOrder', 'O número inserido não é valido, por favor verifique se foi digitado corretamente.')
            return toast.error('Ordem de carregamento inválida.')
          }
          return toast.error(resp.data.error)
        }
        setIsDone(true);
      })
      .catch(() => {
        toast.error("Houve um erro ao cadastrar usuário!");
      }).finally(() => {
        setIsLoading(false)
      });
  };

  const handleGoBack = () => {
    setData({
      ...data,
      cnh: "",
      expirationDate: "",
      toll: "",
      loadingOrder: "",
      numberTN: "",
      socialReason: "",
    });
    changeStep(0);
  };

  const formik = useFormik({
    initialValues: {
      cnh: data.cnh || "",
      expirationDate: data.expirationDate || "",
      toll: data.toll || "",
      loadingOrder: data.loadingOrder || "",
      numberTN: data.numberTN || "",
      socialReason: data.socialReason || "",
      postToken: postToken || ''
    },
    validateOnChange: true,
    validateOnBlur: true,
    validationSchema: isTransporter
      ? validationSchemaTransporter
      : validationSchemaDriver,
    enableReinitialize: true,
    onSubmit: handleSubmitForm,
  });

  const isDisabledBtn = () => {
    if (isTransporter) {
      return (
        !!formik.errors.loadingOrder ||
        !!formik.errors.socialReason ||
        !!formik.errors.numberTN ||
        !!isLoading ||
        (!formik.values.loadingOrder &&
          !formik.values.socialReason &&
          !formik.values.numberTN)
      );
    }

    return (
      !!formik.errors.cnh ||
      !!formik.errors.expirationDate ||
      !!formik.errors.toll ||
      !!isLoading ||
      (!formik.values.cnh &&
        !formik.values.expirationDate &&
        !formik.values.toll)
    );
  };

  if (isDone) {
    return <ConfirmFinish />;
  }

  return (
    <Box className={classes.registrationContainer}>
      <Box className={classes.info}>
        <WarningIcon />
        <Typography className={classes.infoText}>
          Todos os dados devem ser preenchidos exatamente como aparecem na ordem
          de carregamento.
        </Typography>
      </Box>
      <form
        encType="multipart/form-data"
        className={classes.form}
        onSubmit={formik.handleSubmit}
      >
        <Box className={classes.typeClientContainer}>
          <Typography variant="h5" align="left">
            Confirmação de identidade
          </Typography>
          <Typography>
            Responda algumas perguntas para confirmarmos seu direito de acesso.
          </Typography>
        </Box>
        <Box className={classes.inputContainer}>
          <Typography variant="h5" align="left">
            {isTransporter ? "Ordem de carregamento*" : "CNH*"}
          </Typography>
          <TextField
            value={
              isTransporter ? formik.values.loadingOrder : formik.values.cnh
            }
            onBlur={formik.handleBlur}
            onChange={(e) => {
              if (!isTransporter && e.target.value?.length > 11) return;
              if (isTransporter && e.target.value?.length > 20) return;
              formik.handleChange(e);
            }}
            error={
              isTransporter ? !!formik.errors.loadingOrder : !!formik.errors.cnh
            }
            helperText={
              isTransporter
                ? formik.errors.loadingOrder && formik.errors.loadingOrder
                : formik.errors.cnh && formik.errors.cnh
            }
            variant="outlined"
            required
            id={isTransporter ? "loadingOrder-inp" : "cnh-inp"}
            data-cy={isTransporter ? "loadingOrder-inp" : "cnh-inp"}
            name={isTransporter ? "loadingOrder" : "cnh"}
            placeholder={
              isTransporter
                ? "Informe o número de alguma de suas ordens de carregamento"
                : "Informe somente os números de sua CNH"
            }
          />
        </Box>
        <Box className={classes.inputContainer}>
          <Box display="flex">
            <Typography variant="h5" align="left">
              {isTransporter ? "Número TN*" : "Validade da CNH*"}
            </Typography>
            {isTransporter && (
              <Tooltip
                placement="top"
                title="TN ou Transportation Number. O mesmo é encontrado na ordem de carregamento."
                className={classes.infoNumberTN}
              >
                <img className="helpOutlineIcon" src={helpOutlineIcon} alt='Transportation Number' style={{ margin: '0 0 0 8px' }}/>
              </Tooltip>
            )}
          </Box>
          {isTransporter ? (
            <TextField
              value={formik.values.numberTN}
              onBlur={formik.handleBlur}
              onChange={(e) => {
                if (isTransporter && e.target.value?.length > 10) return;
                formik.handleChange(e)
              }}
              error={!!formik.errors.numberTN}
              helperText={formik.errors.numberTN && formik.errors.numberTN}
              variant="outlined"
              required
              id="numberTn-inp"
              data-cy="numberTn-inp"
              name="numberTN"
              placeholder={"Informe o número TN dessa ordem de carregamento"}
            />
          ) : (
            <InputMask
              id="expirationDate-inp"
              data-cy="expirationDate-inp"
              name="expirationDate"
              mask={"99/99/9999"}
              alwaysShowMask={false}
              value={formik.values.expirationDate}
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
            >
              <TextField
                placeholder="dd/mm/aaaa"
                style={{ width: "100%" }}
                variant="outlined"
                error={!!formik.errors.expirationDate}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <InsertInvitationIcon style={{ color: '#666' }} />
                    </InputAdornment>
                  ),
                }}
                helperText={
                  formik.errors.expirationDate && formik.errors.expirationDate
                }
              />
            </InputMask>
          )}
        </Box>
        <Box className={classes.inputContainer}>
          <Typography variant="h5" align="left">
            {isTransporter ? "Razão social*" : "Cartão Pedágio*"}
          </Typography>
          <TextField
            value={
              isTransporter ? formik.values.socialReason : formik.values.toll
            }
            onBlur={formik.handleBlur}
            onChange={(e) => {
              if (!isTransporter && e.target.value?.length > 10) return;
              formik.handleChange(e);
            }}
            error={
              isTransporter
                ? !!formik.errors.socialReason
                : !!formik.errors.toll
            }
            helperText={
              isTransporter
                ? formik.errors.socialReason && formik.errors.socialReason
                : formik.errors.toll && formik.errors.toll
            }
            variant="outlined"
            id={isTransporter ? "socialReason-inp" : "toll-inp"}
            required
            data-cy={isTransporter ? "socialReason-inp" : "toll-inp"}
            name={isTransporter ? "socialReason" : "toll"}
            placeholder={
              isTransporter
                ? "Informe a razão social da transportadora"
                : "Informe somente os números de seu cartão pedágio"
            }
          />
          <input type="hidden" name="postToken" id="postToken" value={formik.values.postToken} />
        </Box>
        <Box className={classes.actionButtons}>
          <Button
            id="goBack-btn"
            data-cy="goBack-btn"
            variant="outlined"
            className="goBack"
            color="primary"
            type="button"
            onClick={handleGoBack}
            size="large"
          >
            <ArrowBackIosIcon /> Voltar
          </Button>
          <Button
            id="next-btn"
            data-cy="next-btn"
            variant="contained"
            className="next"
            color="primary"
            size="large"
            type="submit"
            disabled={isDisabledBtn()}
          >
            Continuar
          </Button>
        </Box>
      </form>
    </Box>
  );
};
